<h3 mat-dialog-title class="montserrat-medium mb-2 text-gray-500">Warning</h3>
<div mat-dialog-content>
    <p>
        {{ getTitle() }}
    </p>
</div>
<div class="d-flex align-items-center justify-content-center" style="gap: 20px">
    <button class="btn btn-md btn-outline-gray-500 mr-3" mat-dialog-close>No</button>
    <button
        mat-dialog-close
        class="btn btn-md btn-gray-500"
        (click)="proceedToStep4InEditMode()"
        cdkFocusInitial
    >
        Yes
    </button>
</div>
